import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import set from 'lodash.set';
import {Button, Message, RedirectWithParams} from 'epic-diesel-common';
import {priority, buttonTypes} from 'epic-diesel-common/src/constants';
import Countries from 'epic-diesel-form/src/constants/Countries';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';

import {
    Payout,
    Paypal,
    Bank,
    LoadIndicator
} from '../../components';
import settingsActions from '../../actions/settings.actions';
import styles from './PayoutForm.pcss';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    settingsState: state.get('settings'),
    influencerState: state.get('influencer').toJS(),
    userState: state.get('user').toJS(),
    configState: state.get('config').toJS()
});
const mapDispatchToProps = dispatch => ({
    getSettings: () => {
        dispatch(settingsActions.getPayout());
    },
    updateSettings: data => {
        dispatch(settingsActions.updateSettings(data));
    }
});
@connect(mapStateToProps, mapDispatchToProps)
export default class PayoutForm extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        getSettings: PropTypes.func,
        updateSettings: PropTypes.func,
        settingsState: PropTypes.object,
        configState: PropTypes.object,
        influencerState: PropTypes.object,
        userState: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            loadingPayout: true,
            form: {
                payoutMethod: 'bank',
                foreignTax: false,
                foreignBank: false,
                businessType: '',
                taxType: '',
                country: 'US'
            },
            disablePayout: false,
            disableTax: false
        };
    }

    componentDidMount() {
        const {isLoggedIn} = this.props.userState.accountInfo;
        if (isLoggedIn) {
            this.props.getSettings();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {settingsState} = nextProps;

        const settingsData = settingsState.toJS();
        const {payoutAccount, taxInfo, loadingPayout, updateFailed} = settingsData;
        let {payoutMethod} = this.state.form;
        if (payoutAccount && Object.keys(payoutAccount).length !== 0) {
            payoutMethod = payoutAccount.gatewayType === 'PAYPAL' ? 'paypal' : 'bank';

            this.setState({
                disablePayout: payoutAccount.accountStatus !== 'DRAFT'
            });
        }
        if (!loadingPayout && !updateFailed && taxInfo && Object.keys(taxInfo).length !== 0) {
            const disableTax = taxInfo.status !== 'DRAFT';
            this.setState({
                disableTax,
                loadingPayout,
                form: {
                    ...this.state.form,
                    payoutMethod,
                    ...payoutAccount,
                    ...settingsData.profile,
                    ...taxInfo,
                    ...taxInfo.address,
                    foreignTax: taxInfo.address && taxInfo.address.country !== 'US'
                }
            });
        } else {
            this.setState({
                loadingPayout,
                form: {
                    ...this.state.form,
                    payoutMethod,
                    ...payoutAccount,
                    ...settingsData.profile
                }
            });
        }
    }

    submitForm = model => {
        const payload = {};
        if (!this.state.disablePayout) {
            payload.payout = model;
            const settingsData = this.props.settingsState.toJS();
            payload.payout.payoutAccountId =
                settingsData.payoutAccount && settingsData.payoutAccount.id;
        }
        if (!this.state.disableTax) {
            payload.tax = model;
            payload.w9form = model;
        }
        this.props.updateSettings(payload);
    };

    trigger = (name, value) => {
        const {form} = this.state;
        if (
            name === 'foreignTax' &&
            (form.foreignTax === value || form.foreignTax === (value === 'true'))
        ) {
            return;
        }
        if (name === 'taxType' && form.taxType === value) return;
        if (name === 'foreignBank') {
            set(form, name, value === 'true');
        } else {
            set(form, name, value);
        }
        if (name === 'foreignTax') {
            form.taxType = '';
            form.taxId = '';
            form.foreignTax = value === 'true';
            form.country = form.foreignTax ? Countries.slice(1)[0].value : 'US';
        } else if (name === 'businessType') {
            if (!form.foreignTax) form.taxType = form.businessType === 'INDIVIDUAL' ? 'SSN' : 'EIN';
        } else if (name === 'taxType') {
            form.taxId = '';
        }
        this.setState({form});
    };

    render() {
        const {messages, userState, influencerState} = this.props;

        const {affiliateAccount} = influencerState;
        const {accountInfo} = userState;
        const {isLoggedIn} = accountInfo;

        if (!affiliateAccount || affiliateAccount.status !== 'ACTIVE') {
            return <RedirectWithParams to="/affiliate/overview" />;
        }

        const {form, disablePayout, disableTax, loadingPayout} = this.state;
        return (
            <>
                <div className={isLoggedIn ? styles.container : styles.containerLogin}>
                    <LoadIndicator isLoading={loadingPayout} messages={messages}>
                        <div className={styles.title}>
                            <Message code="epic.affiliate.hyperwallet.restricted.help" />
                        </div>
                        {
                            !loadingPayout && <FormsyForm className={styles.settingSection} submitForm={this.submitForm} callbackDelay={2000}>
                                <Payout
                                    messages={messages}
                                    form={form}
                                    trigger={this.trigger}
                                    disabled={disablePayout}
                                />
                                {form.payoutMethod === 'bank' ? (
                                    <Bank
                                        messages={messages}
                                        form={form}
                                        trigger={this.trigger}
                                        disabled={disablePayout}
                                    />
                                ) : (
                                    <Paypal
                                        messages={messages}
                                        form={form}
                                        trigger={this.trigger}
                                        disabled={disablePayout}
                                    />
                                )}
                                {!(disablePayout && disableTax) && (
                                    <>
                                        <Button
                                            type={buttonTypes.SUBMIT}
                                            priority={priority.PRIMARY}
                                            disabled={disablePayout}
                                            theme="dark">
                                            <Message code="epic.affiliate.common.submit" />
                                        </Button>
                                    </>
                                )}
                            </FormsyForm>
                        }
                    </LoadIndicator>
                </div>
            </>
        );
    }
}
